<template>
  <table class="props-compact mb-4">
    <tr>
      <th>Host</th>
      <td>{{conf.host}}</td>
    </tr>
    <tr>
      <th>Port</th>
      <td>{{conf.port}}</td>
    </tr>
    <tr>
      <th>Db</th>
      <td>{{conf.db}}</td>
    </tr>
    <tr>
      <th>Prefix</th>
      <td><code>{{conf.prefix}}</code></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'RedisConnectionConfView',

  props: {
    conf: {
      type: Object,
      required: true,
    }
  },
};
</script>
